import { Button, Flex, keyframes, Text } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'

import { Pagination } from '@base/@types/components/Layout/TableGrid'

interface IGridQuantity {
  data?: any[]
  pagination?: Pagination
  isLoading?: boolean
  disabled?: boolean
  textButton?: string
  qtd?: string
  onClick?: () => void
}

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`

const GridQuantity: FC<IGridQuantity> = ({
  data,
  pagination,
  isLoading,
  disabled,
  textButton,
  qtd,
  onClick
}) => {
  const [isPulsing, setIsPulsing] = useState(false)

  useEffect(() => {
    if (pagination?.actualPage) {
      // Quando a página atual muda, ativa a animação
      setIsPulsing(true)

      // Remove a animação após 0.5 segundos (duração da animação)
      const timeout = setTimeout(() => {
        setIsPulsing(false)
      }, 500)

      return () => clearTimeout(timeout)
    }
  }, [pagination?.actualPage])
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      paddingRight={4}
      paddingLeft={3}
      paddingY={2}
    >
      <Text fontSize={14}>
        Quantidade de Registros:{' '}
        {qtd != null ? qtd : data ? data.length : pagination?.totalRows}
      </Text>
      {pagination != null && pagination.totalPages != null && (
        <>
          <Text
            fontSize={14}
            animation={isPulsing ? `${pulseAnimation} 0.5s ease` : 'none'}
          >
            {pagination?.actualPage} de {pagination?.totalPages}
          </Text>
        </>
      )}

      {textButton && (
        <Button
          fontSize={14}
          size="sm"
          color="#2F855A"
          borderRadius={5}
          border="1px solid #2F855A"
          cursor="pointer"
          isLoading={isLoading}
          disabled={disabled}
          transition="all ease .2s"
          _hover={{
            background: '#9AE6B4',
            color: '#1b4f35'
          }}
          onClick={onClick}
        >
          {textButton}
        </Button>
      )}
    </Flex>
  )
}

export default GridQuantity
